// Module imports
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { HoldingsCategoriesTableModule } from 'SecuritiesApp/ts/features/holdings-categories-table/holdings-categories-table.module';
// Components
import { HoldingsCategoriesTableComponent } from 'SecuritiesApp/ts/features/holdings-categories-table/holdings-categories-table.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsHoldingsCategorizeModule {
}
MutualFundsHoldingsCategorizeModule.ɵfac = function MutualFundsHoldingsCategorizeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsHoldingsCategorizeModule)(); };
MutualFundsHoldingsCategorizeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsHoldingsCategorizeModule, bootstrap: [HoldingsCategoriesTableComponent,
        TopBarNavComponent,
        SideMenuComponent,
        SecurityHeaderControlComponent] });
MutualFundsHoldingsCategorizeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, HoldingsCategoriesTableModule] });
